function syncStickyForm() {
  const stickyForm = document.querySelector('#sticky-product-form');
  if (!stickyForm) return;

  const stickyPrice = stickyForm.querySelector('price-list');
  const stickyPlanSelect = stickyForm.querySelector('#sticky_selling_plan');
  //  const testimonialPrice1 = document.querySelector('.testimonial price-list.price-lis sale-price.product_price');
  const testimonialSubscriptionPeriodDropdown = document.querySelectorAll(".testimonial select");
  console.log("testimonialSubscriptionPeriodDropdown:", testimonialSubscriptionPeriodDropdown);

  const selectedRadio = document.querySelector('.rc-radio__input:checked');
  if (!selectedRadio) return;

  const optionWrapper = selectedRadio.closest('.rc-radio');
  const priceEl = optionWrapper?.querySelector('.rc-option__price');
  const priceText = priceEl?.textContent.trim();

  // Update sticky price only if it changed
  if (priceText && stickyPrice && stickyPrice.textContent.trim() !== priceText) {
    stickyPrice.textContent = priceText;
    // testimonialPrice1.innerHTML = priceText;

  }

  // Update sticky plan dropdown only if.  it changed
  if (selectedRadio.classList.contains('rc_widget__option__input--onetime')) {
    if (stickyPlanSelect && stickyPlanSelect.value !== '') {
      stickyPlanSelect.value = '';
      testimonialSubscriptionPeriodDropdown.forEach((item) => {
        item.value = '';
      });
    }
  }
  else if (selectedRadio.classList.contains('rc_widget__option__input--subsave')) {
    const rechargeDropdown = optionWrapper.querySelector('.rc-selling-plans__dropdown');
    const selectedSubscriptionPeriodIndex = rechargeDropdown.selectedIndex;
    if (rechargeDropdown && stickyPlanSelect && stickyPlanSelect.value !== rechargeDropdown.value) {
      stickyPlanSelect.value = rechargeDropdown.value;
      testimonialSubscriptionPeriodDropdown.forEach((item) => {
        item.selectedIndex = selectedSubscriptionPeriodIndex + 1;
      });       
    }
  }

  
}

function getVariantIdFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get('variant'); // returns the variant ID or null
}


function updateStickyImage(variantId) {
   // Find the gallery image that matches the variant ID
  var variantImage = document.querySelector('.product-gallery__media[data-variant-id="' + variantId + '"] img');

  if (variantImage) {
    // Update the sticky bar image
    var stickyImg = document.querySelector('.product-sticky-bar__info img');
    if (stickyImg) {
      stickyImg.src = variantImage.src;
      stickyImg.srcset = variantImage.srcset || '';
      stickyImg.alt = variantImage.alt || '';
      stickyImg.title = variantImage.title || '';
    }

    
    // Update all product card images
    var productCardImages = document.querySelectorAll('.product-card1 .product-card__media img');
    productCardImages.forEach(function(img) {
      img.src = variantImage.src;
      img.srcset = variantImage.srcset || '';
      img.alt = variantImage.alt || '';
      img.title = variantImage.title || '';
    });
  }
}

  // document.querySelectorAll('.product-card .product-card__media').forEach(function(media) {
  //   var cardProductId = media.closest('[data-product-id]')?.dataset.productId;

  //   if (cardProductId && cardProductId === currentProductId) {
  //     var img = media.querySelector('img');
  //     if (!img) return;

  //     img.src = variantImage.src;
  //     img.srcset = variantImage.srcset || '';
  //     img.alt = variantImage.alt || '';
  //     img.title = variantImage.title || '';
  //   }
  // });
//   }
// }


document.addEventListener('DOMContentLoaded', () => {
  // Run once only on refresh
  setTimeout(() => {
    const firstVariantRadio = document.querySelector(
      '.variant-picker__option-values input[type="radio"]'
    );

    if (!firstVariantRadio) return;

    // Force select first variant
    firstVariantRadio.checked = true;
    firstVariantRadio.dispatchEvent(new Event('change', { bubbles: true }));

    // OPTIONAL: reset URL to first variant
    const firstLabel = firstVariantRadio.closest('.option_wrapper')?.querySelector('label[data-variant-id]');
    if (firstLabel) {
      const variantId = firstLabel.getAttribute('data-variant-id');
      if (variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }
    }

  }, 200); // small delay so Shopify scripts are ready
});

  
// Run on page load
document.addEventListener('DOMContentLoaded', syncStickyForm);

  // Initial load — set sticky image based on selected variant
  var initialVariantInput = document.querySelector('input[name="id"]'); // hidden input in sticky form
  if (initialVariantInput) {
    updateStickyImage(initialVariantInput.value);
  }



// Run on any Recharge change
document.addEventListener('change', function (e) {
  if (!e.target.matches('.rc-radio__input, .rc-selling-plans__dropdown')) return;
  syncStickyForm();
});



document.addEventListener("DOMContentLoaded", function () {
  const containerSelector = '.variant-picker__option-values';
  const stickyPriceRoot = document.querySelector('#sticky-product-form price-list');
  // const testimonialPrice = document.querySelector('.testimonial price-list.price-lis sale-price.product_price');
  
// Grab sticky subscription dropdown
var stickyPlanSelect = document.querySelector('#sticky_selling_plan');
  const testimonialSubscriptionPeriodDropdown = document.querySelectorAll(".testimonial select");

if (stickyPlanSelect) {
  stickyPlanSelect.addEventListener('change', function () {
    var selectedValue = stickyPlanSelect.value;

    // --- Update Recharge legacy radios ---
    var rcOnetime = document.querySelector('.rc_widget__option__input--onetime');
    var rcSubsave = document.querySelector('.rc_widget__option__input--subsave');
    var rcDropdown = document.querySelector('.rc_widget__option__plans__dropdown');

    if (selectedValue === '' && rcOnetime) {
        testimonialSubscriptionPeriodDropdown.forEach((item) => {
        item.value = '';
      });
      // One-time purchase selected in sticky
      rcOnetime.checked = true;
      rcOnetime.dispatchEvent(new Event('change', { bubbles: true }));
      if (rcDropdown) rcDropdown.value = ''; // Clear any plan
    } 
    else if (rcSubsave && rcDropdown) {
      // Subscribe & Save selected in sticky
      rcSubsave.checked = true;
      rcDropdown.value = selectedValue; // match plan
      rcSubsave.dispatchEvent(new Event('change', { bubbles: true }));
      rcDropdown.dispatchEvent(new Event('change', { bubbles: true }));
      rcDropdown.value = selectedValue; // match plan
    const selectedSubscriptionPeriodIndex = stickyPlanSelect.selectedIndex;

        testimonialSubscriptionPeriodDropdown.forEach((item) => {
        item.selectedIndex = selectedSubscriptionPeriodIndex;
      });
    }
  });
}

var testimonialPlanSelect = document.querySelector('.product-card1 select');

if (testimonialPlanSelect) {
  testimonialPlanSelect.addEventListener('change', function () {
    var selectedValue1 = testimonialPlanSelect.value;

    // --- Update Recharge legacy radios ---
    var rcOnetime1 = document.querySelector('.rc_widget__option__input--onetime');
    var rcSubsave1 = document.querySelector('.rc_widget__option__input--subsave');
    var rcDropdown1 = document.querySelector('.rc_widget__option__plans__dropdown');

    if (selectedValue1 === '' && rcOnetime1) {
      // One-time purchase selected in sticky
      rcOnetime1.checked = true;
      rcOnetime1.dispatchEvent(new Event('change', { bubbles: true }));
      if (rcDropdown1) rcDropdown1.value = ''; // Clear any plan
    } 
    else if (rcSubsave1 && rcDropdown1) {
      // Subscribe & Save selected in sticky
      rcSubsave1.checked = true;
      rcDropdown1.value = selectedValue1; // match plan
      rcSubsave1.dispatchEvent(new Event('change', { bubbles: true }));
      rcDropdown1.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

function syncPriceFromActiveVariant() {
  const activeWrapper = document.querySelector('.option_wrapper.active');
  if (!activeWrapper) return;

  const priceText = activeWrapper.getAttribute('data-variant-price');
  const testimonialProductPrice = document.querySelectorAll(".product-info-below__BeforeAfter price-list sale-price");
  if(testimonialProductPrice) {
    testimonialProductPrice.forEach((item) => {
      item.innerHTML = `<span class="sr-only">Sale price</span>${priceText.split(" ")[0]}`;
    });
  }  
  if (!priceText) return;

  // Update everywhere
  // document.querySelectorAll(`
  //   #sticky-product-form price-list,
  //   .testimonial sale-price,
  //   .rc_widget__price--onetime,
  //   .show_price
  // `).forEach(el => {
  //   el.textContent = priceText;
  // });
}

  
  function refreshActive(container) {
    let selectedPrice = '';

    container.querySelectorAll('.option_wrapper').forEach(wrapper => {
      wrapper.classList.remove('active');
      const radio = wrapper.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        wrapper.classList.add('active');
        selectedPrice = wrapper.getAttribute('data-variant-price') || '';
      }
    });
    syncPriceFromActiveVariant();

    const priceElement = document.querySelector('.show_price');
    if (priceElement && selectedPrice) {
     priceElement.innerHTML = selectedPrice;
    }
     const priceOneTime = document.querySelector('.rc-option__price.rc_widget__price--onetime');
    if (priceOneTime && selectedPrice) {
     priceOneTime.innerHTML = selectedPrice;
    }
    
    stickyPriceRoot.innerHTML = selectedPrice || '';
    // testimonialPrice.innerHTML = selectedPrice || '';
    const priceSubSave = document.querySelector('.rc-option__price.rc_widget__price--subsave');


    

    function parseNumericFragment(raw) {
        // Normalize common group separators: apostrophe and spaces
        raw = raw.replace(/'/g, '').replace(/\s+/g, '');
        // If contains both dot and comma, decide which is decimal by position
        const lastDot = raw.lastIndexOf('.');
        const lastComma = raw.lastIndexOf(',');
        let cleaned = raw;

        if (lastComma > -1 && lastDot > -1) {
            // If comma comes after dot, comma is decimal separator (European style)
            if (lastComma > lastDot) {
                cleaned = raw.replace(/\./g, '').replace(',', '.');
            } else {
                // dot is decimal, remove commas
                cleaned = raw.replace(/,/g, '');
            }
        } else if (raw.includes(',')) {
            // Only commas present: decide if comma is decimal (e.g. "12,50") or thousands ("1,299")
            const parts = raw.split(',');
            const lastPart = parts[parts.length - 1];
            if (lastPart.length === 2) {
                // likely decimal cents "12,50" -> "12.50"
                cleaned = raw.replace(/,/g, '.');
            } else {
                // likely thousand separators -> remove them
                cleaned = raw.replace(/,/g, '');
            }
        } else {
            // no comma, maybe only dots; remove thousands separators if any (rare) else keep dot as decimal
            // keep as-is, but also remove stray thousands like "12.900.00" (two dots)
            const dotCount = (raw.match(/\./g) || []).length;
            if (dotCount > 1) {
                // assume dots used as thousands and one decimal - remove all dots except last as decimal
                const last = raw.substring(raw.lastIndexOf('.'));
                cleaned = raw.replace(/\./g, '').replace(last.replace('.', ''), last);
            } else {
                cleaned = raw;
            }
        }

        // Final cleanup: remove any non-digit/decimal char left
        cleaned = cleaned.replace(/[^0-9.]+/g, '');

        const value = parseFloat(cleaned);
        return isNaN(value) ? null : value;
    }

    function discount15FromString(str, options = { keepCurrency: false, formatWithThousands: false }) {
        if (!str || typeof str !== 'string') return null;

        // Find all numeric-like fragments
        const fragments = str.match(/[\d][0-9\.,'\s]*/g) || []; // find sequences starting with digit
        const parsed = [];

        for (const frag of fragments) {
            const v = parseNumericFragment(frag);
            if (v !== null) parsed.push({ raw: frag.trim(), value: v });
        }

        if (parsed.length === 0) {
            console.log('No numeric fragments found in:', str);
            return null;
        }

        // Choose the best candidate:
        // prefer the largest number > 1 (prices are usually >1). If none >1, choose the max
        let candidates = parsed.filter(p => p.value > 1);
        let chosen = (candidates.length ? candidates : parsed).reduce((a, b) => (a.value >= b.value ? a : b));

        console.log('Found numeric fragments:', parsed);
        console.log('Chosen fragment to discount:', chosen);

        // Apply discount
        const discountedValue = +(chosen.value * 0.85).toFixed(2);

        // Format discounted number optionally with thousands separators
        let discountedStr;
        if (options.formatWithThousands) {
            // Use user's locale by default (if unavailable will fallback)
            discountedStr = discountedValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        } else {
            discountedStr = discountedValue.toFixed(2);
        }

        if (options.keepCurrency) {
            // Replace only the chosen.raw inside the original string with the discounted string
            // Use first exact occurrence (trim spaces for safety)
            const re = new RegExp(chosen.raw.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));
            return str.replace(re, discountedStr);
        }

        // Default: return only the discounted number
        return discountedStr;
    }

    // USAGE
    if (priceSubSave && selectedPrice) {
        // DEBUG: try both modes
        const discountedOnly = discount15FromString(selectedPrice, { keepCurrency: false, formatWithThousands: false });
        const discountedWithCurrency = discount15FromString(selectedPrice, { keepCurrency: true, formatWithThousands: true });
        const selectedRadio = document.querySelector('.rc-radio__input:checked');

        // Choose what you want displayed:
        // priceSubSave.innerHTML = discountedOnly;               // Just number: "10965.00"
        priceSubSave.innerHTML = discountedWithCurrency || discountedOnly || ''; // Keep currency and formatting if possible
        if (selectedRadio.classList.contains('rc_widget__option__input--subsave')) {
           stickyPriceRoot.innerHTML = discountedWithCurrency || discountedOnly || '';
          //  testimonialPrice.innerHTML = discountedWithCurrency || discountedOnly || '';
        }

      
    }
    

  }


  // Delegated click handler
  document.body.addEventListener('click', function (e) {
    const wrapper = e.target.closest('.option_wrapper');
    if (!wrapper) return;

    const container = wrapper.closest(containerSelector);
    if (!container) return;

    const radio = wrapper.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      refreshActive(container);
    }
  });



  // Delegated change handler (after Shopify JS runs)
document.body.addEventListener('change', function (e) {
  if (e.target.matches(containerSelector + ' input[type="radio"]')) {
    const container = e.target.closest(containerSelector);
    if (container) refreshActive(container);

    // Use setTimeout correctly
    setTimeout(() => {
      const initialVariantId = getVariantIdFromUrl() || document.querySelector('input[name="id"]')?.value;
       const stickyFormNew = document.querySelector('#sticky-product-form');
      if (initialVariantId) {
          const variantInput = stickyFormNew.querySelector('input[name="id"]');
            if (variantInput && initialVariantId) {
              variantInput.value =initialVariantId;
            }
        updateStickyImage(initialVariantId);
      }
    }, 500); // 500ms to ensure Shopify updates hidden input

  // Use setTimeout correctly
    setTimeout(() => {
      const initialVariantId1 = getVariantIdFromUrl() || document.querySelector('input[name="id"]')?.value;
       const testimonialFormNew = document.querySelector('#product_form_7846779912271');
      if (initialVariantId1) {
          const variantInput1 = testimonialFormNew.querySelector('input[name="id"]');
            if (variantInput1 && initialVariantId1) {
              variantInput1.value =initialVariantId1;
            }
        updateStickyImage(initialVariantId1);
      }
    }, 500); // 500ms to ensure Shopify updates hidden input

    // syncRechargePriceFromActiveVariant();

  }
});


  // Initial refresh for pre-checked option
  document.querySelectorAll(containerSelector).forEach(refreshActive);
});


//adding footer margin due to footer bar
document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector("footer");
  const stickyBar = document.querySelector("product-sticky-bar"); // tag selector

  if (!footer || !stickyBar) return;

  function adjustFooterMargin() {
    if (stickyBar.classList.contains("is-visible")) {
      footer.style.marginBottom = stickyBar.offsetHeight + "px";
    } else {
      footer.style.marginBottom = "";
    }
  }

  // Initial run
  adjustFooterMargin();

  // Update on window resize
  window.addEventListener("resize", adjustFooterMargin);

  // Watch for class/style changes
  new MutationObserver(adjustFooterMargin).observe(stickyBar, {
    attributes: true,
    attributeFilter: ["class", "style"]
  });

  // Watch for height/content changes (dynamic subscription etc.)
  if ("ResizeObserver" in window) {
    new ResizeObserver(adjustFooterMargin).observe(stickyBar);
  }
});


document.addEventListener("DOMContentLoaded", () => {
  // Function to check and add class
  function checkAndAddClass() {
    document.querySelectorAll('.buy_wrapper').forEach(wrapper => {
      if (wrapper.classList.contains('has-rc-container')) return;
      const form = wrapper.querySelector('form');
      if (!form) return;
      if (form.querySelector('.rc-container-wrapper.rc_container_wrapper')) {
        wrapper.classList.add('has-rc-container');
        // console.log('Class added to', wrapper);
      }
    });
  }

  // Run once on page load
  checkAndAddClass();

  // Observe for future DOM changes (e.g., Recharge box injection)
  const observer = new MutationObserver(() => {
    checkAndAddClass();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector("footer");
  if (!footer) return;

  function checkStickyBar() {
    const stickyBar = document.querySelector(".product-sticky-bar.is-visible");

    if (stickyBar) {
      footer.classList.add("has-sticky-bar");

      // If sticky bar has subscription class
      if (stickyBar.classList.contains("has-rc-container")) {
        footer.classList.add("has-rc-container");
      } else {
        footer.classList.remove("has-rc-container");
      }
    } else {
      footer.classList.remove("has-sticky-bar", "has-rc-container");
    }
  }

  // Run once on load
  checkStickyBar();

  // Watch for changes in the DOM
  const observer = new MutationObserver(checkStickyBar);
  observer.observe(document.body, { childList: true, subtree: true });
});



function checkReChargeOptions() {
  const parentWrapper = document.querySelector('.buy_wrapper.has-rc-container');
  const legacyRadio = document.querySelector('.rc-template__legacy-radio');

  if (!parentWrapper || !legacyRadio) {
    return;
  }

  const radioOptions = legacyRadio.querySelectorAll('.rc-radio');

  if (radioOptions.length >= 2) {
    parentWrapper.classList.add('has-two-radios');
    clearInterval(checkInterval); // stop checking once done
  }
}

const checkInterval = setInterval(checkReChargeOptions, 500); // runs until found


